export default __webpack_public_path__ + "a480de87a05feed0db9603b7e07ff2dc-gotham-medium-webfont.woff";